module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (107).54c9c603.jpg";